//JS file

import { initBackToTop } from '../storybook/js/back-to-top.js';
import "./components/navigation";
import "./components/print";
import "./components/search-form";
import "./components/toggle-display";

document.addEventListener('DOMContentLoaded', () => {
    initBackToTop();
});
